import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const SlidersIcon = memo(({ className }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'none' }}
  >
    <circle cx="4.69512" cy="4.69512" r="4.69512" transform="matrix(-1 0 0 1 35 25.6097)" fill="#F0CBA7" />
    <circle cx="4.69512" cy="4.69512" r="4.69512" transform="matrix(-1 0 0 1 11.9512 1.70734)" fill="#F0CBA7" />
    <circle cx="4.69512" cy="4.69512" r="4.69512" transform="matrix(-1 0 0 1 23.0488 12.8049)" fill="#F0CBA7" />
    <path d="M8.53662 5.12195L32.4391 5.12195" stroke="#EA7200" strokeWidth="1.5" />
    <path d="M0 28.1707H23.4756" stroke="#EA7200" strokeWidth="1.5" />
    <path d="M20.4878 16.2195H33.2927" stroke="#EA7200" />
    <path d="M11.5244 16.2195H0" stroke="#EA7200" strokeWidth="1.5" />
    <path
      d="M27.7437 24.6525C25.5649 24.6526 23.7983 26.419 23.7983 28.5978C23.7984 30.7765 25.565 32.543 27.7437 32.5431C29.9224 32.5431 31.6889 30.7765 31.689 28.5978C31.689 26.4189 29.9225 24.6525 27.7437 24.6525Z"
      stroke="#EA7200"
      strokeWidth="1.5"
    />
    <circle
      cx="4.69512"
      cy="4.69512"
      r="3.94512"
      transform="matrix(-1 0 0 1 9.39026 0)"
      stroke="#EA7200"
      strokeWidth="1.5"
    />
    <circle
      cx="4.69512"
      cy="4.69512"
      r="3.94512"
      transform="matrix(-1 0 0 1 20.4878 11.0975)"
      stroke="#226937"
      strokeWidth="1.5"
    />
  </SvgIcon>
));
